module.exports = __webpack_public_path__ + "img/Light_Transparent.6bab865f.png";